<footer class="footer">
  <div class="footer__content">
    <div class="footer__left">
      <div class="footer__logo">
        <img [alt]="logoDescription" [src]="logo" />
      </div>
      <div class="footer__social">
        <ng-content select="un-social-link"></ng-content>
      </div>
    </div>
    <div class="footer__right">
      <ng-content select="un-footer-link"></ng-content>
    </div>
  </div>
</footer>
